import { CalciteSelect, CalciteOption } from '@esri/calcite-components-react';
import { undefBool } from '../../../util/webComponentUtils';
import { useEditorFocus } from './useEditorFocus';

export const DomainCellEditor: CellEditor = ({
  domain,
  onChange,
  disabled = false,
  value,
  autoEdit,
}) => {
  const ref = useEditorFocus<HTMLCalciteSelectElement>((el) => {
    el.setFocus();
  }, autoEdit);

  if (!domain?.codedValues) return null;

  return (
    <CalciteSelect
      className="w-full h-full"
      label="Select"
      onCalciteSelectChange={(e) => onChange(e.target.value)}
      placeholder="Select"
      defaultValue={value?.toString()}
      disabled={undefBool(disabled)}
      ref={ref}
    >
      {domain.codedValues.map(({ code, name }) => (
        <CalciteOption
          value={code.toString()}
          key={code}
          selected={value?.toString() === code.toString()}
        >
          {name}
        </CalciteOption>
      ))}
    </CalciteSelect>
  );
};
